<template>
    <div class='full-vertical-container'>
        <h5 v-if="description"> {{description}} </h5>
        <iframe v-bind:src="src" class='resp-iframe' frameborder='0' allowfullscreen></iframe>
    </div>
</template>

<script>
    export default {
        name: 'IFrameComponent',
        props: ["src"],
        data() {
            return {
                items: [],
                description: ""
            }
        },
        method: {
            test() {
            }
        }

    }
</script>

<style scoped>
    .resp-iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }

    .full-vertical-container {
        position: relative;
        overflow: hidden;
        padding-top: 55%;
    }
</style>
